module.exports = __webpack_public_path__ + "img/course123_summary_unit_timelines.afc71335.png";